module.exports = __webpack_public_path__ + "media/images/calendar-0e8731f4167e504b9403608da9f598c1.svg";